import { http } from 'http';

export default {
  getMasterData: () => http.get('/masterdata'),
  getDriver: driverIdEncrypted => http.get(`/driversweb/drivers?driverId=${driverIdEncrypted}`),
  getVehicle: carPlateEncrypted =>
    http.get(`/driversweb/vehicles/plate?plate=${carPlateEncrypted}`),
  getInterventions: carPlateEncrypted =>
    http.get(`/driversweb/vehicles/interventions?plate=${carPlateEncrypted}`),
  getInterventionsHistoric: carPlateEncrypted =>
    http.get(`/driversweb/vehicles/interventions/historic?plate=${carPlateEncrypted}`),
  getNotifications: (driverIdEncrypted, carPlateEncrypted) =>
    http.get(
      `/driversweb/drivers/notifications?driverId=${driverIdEncrypted}&plate=${carPlateEncrypted}`
    ),
  getOperations: carPlateEncrypted =>
    http.get(`driversweb/vehicles/operation?plate=${carPlateEncrypted}`),
  getPriorAppointments: vehicleIdEncrypted =>
    http.get(`driversweb/vehicles/priorappointments?idVehicle=${vehicleIdEncrypted}`),
  getInfoUser: userId => http.get(`/LegacyApi/app/GetInfoUser/${userId}`),
  getTownsByCp: cp => http.get(`towns/${cp}`),
  getDriverAvatar: driverIdEncrypted =>
    http.get(`/driversweb/drivers/avatar?driverId=${driverIdEncrypted}`),
  getIncidentsDgt: provinceIdEncrypted =>
    http.get(`/driversweb/incidents?region=${provinceIdEncrypted}`),
  legalConditionsData: step => http.get(`/driversweb/driversconsentsgroups/${step}`),
  getTypesIncidents: () => http.get('/driversweb/GetTiposIncidenciasCRM'),
  getLevel2: typesIncidents =>
    http.get(`/driversweb/GetNivel2CRM?tipoIncidencia=${typesIncidents}`),
  getLevel3: (typesIncidents, level2) =>
    http.get(`/driversweb/GetNivel3CRM?tipoIncidencia=${typesIncidents}&nivel2=${level2}`),
  documentationMasterdata: () => http.get(`/driversweb/authorizationvehicle/masterdata`),
  replacementvehicleMasterdata: () => http.get(`/driversweb/replacementvehicle/masterdata`),
  getTownsByProvinceCode: provinceCode => http.get(`towns?provinceCode=${provinceCode}`)
};
